import React, { Fragment } from 'react';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';
import { FormattedMessage, injectIntl } from 'react-intl';

import HowItWorksSolverPageService from './how-it-works-solver.service.js';
import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import BulletList from '../../components/bullet-list/bullet-list.js';
import Seo from '../../infrastructure/seo.js';
import ScrollToTop from '../../shared/utils.js';

import './how-it-works-solver.scss';

const Description = ({ data }) => (
	<section className="introduction">
		<div className="container container-fluid">
			<div className="row">
				<div className="col-xs-12 col-md-4 top-xs start-xs">
					{data.title && <h1 className="title">{data.title}</h1>}
				</div>
				<div
					className="col col-xs-12 col-md-8 col-lg-8 top-xs start-xs description"
					dangerouslySetInnerHTML={{ __html: data.description }}
				/>
			</div>
		</div>
	</section>
);

const JoinCard = ({ data }) => (
	<section className="join-card">
		<div className="container container-fluid">
			<div className="row">
				<div className="col-xs-12 middle-xs center-xs">
					<div className="card">
						<p>{data}</p>
						<a
							target="_blank"
							rel="noopener noreferrer"
							href="https://platform.inocrowd.com.pt/sign-up"
							className="btn-hover-effect"
						>
							<FormattedMessage id="howItWorks.solver.button">
								{txt => <Fragment>{txt}</Fragment>}
							</FormattedMessage>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
);

class HowItWorksSolverPage extends React.Component {
	static prefetchData = async language => HowItWorksSolverPageService.getSolverData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		const { solver, setLoading } = this.props;

		ScrollToTop();

		if (!solver) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language } = this.props;

		ScrollToTop();

		if (prevProps.language.value !== language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		const { language, setSolver, setLoading } = this.props;

		setLoading(true);

		HowItWorksSolverPage.prefetchData(language.value)
			.then((res) => {
				setSolver(res);
				setLoading(false);
			})
			.catch(() => {
				this.setState({ hasError: true });
				setLoading(false);
			});
	}

	render() {
		const {
			solver,
			intl: { formatMessage },
			addresses,
			phones,
			generalData,
		} = this.props;
		const { hasError } = this.state;

		const regex = /(<([^>]+)>)/ig;

		if (hasError || !solver) {
			return <NotImplemented title="How it works" />;
		}

		return (
			<div className="how-it-works-solver-page">
				<Seo
					title={solver.title || formatMessage({ id: 'navigation.howItWorks.solver' })}
					description={solver.description.replace(regex, '') || solver.title || formatMessage({ id: 'navigation.howItWorks.solver' })}
					image={solver.image ? `${process.env.REACT_APP_API_ENDPOINT}${solver.image.path}` : ''}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.howItWorks.solver' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/how-it-works/solver"
												}
											]
										}
									]
								}`}
				/>
				<Description data={solver} />
				{solver.image && (
					<div
						className="image"
						style={{
							backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT
								+ solver.image.path}')`,
						}}
					/>
				)}
				<div className="section">
					<BulletList data={solver} />
				</div>
				<div className="section">
					{solver.platform_cta && <JoinCard data={solver.platform_cta} />}
				</div>
			</div>
		);
	}
}

const mapToProps = ({ language, solver, addresses, phones, generalData }) => ({
	language,
	solver,
	addresses,
	phones,
	generalData,
});

export default injectIntl(
	connect(
		mapToProps,
		actions,
	)(HowItWorksSolverPage),
);

export { HowItWorksSolverPage };
